import React from 'react';
import ReactDOM from 'react-dom/client';
// import './assets/css/style.css';
import './index.css';
import App from './App';
import '../src/assets/css/style.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);


